const videoBackgroundModule = () => {
    const videos = document.querySelectorAll('.js-video-background');

    if (!videos.length) return;

    const breakpoint =
        getComputedStyle(document.documentElement)
            .getPropertyValue('--breakpoint-md')
            .trim() || '768px';

    const mobile = window.matchMedia(`(max-width: ${parseInt(breakpoint, 10) - 1}px)`);

    const setSource = (video) => {
        const url = mobile.matches
            ? video.dataset.videoMobile
            : video.dataset.videoDesktop;

        if (!url || video.dataset.videoCurrent === url) return;

        video.dataset.videoCurrent = url;
        video.src = url;
        video.load();

        const played = video.play();
        if (played) played.catch(() => {});
    };

    const setSources = () => videos.forEach(setSource);

    setSources();

    mobile.addEventListener('change', setSources);
};

export default videoBackgroundModule;
